/* ============================================================
   Archive44 — main.js v3
   Mobile nav, product rendering, reviews, drag scroll, cart
   ============================================================ */

// ----- MOBILE NAV -----
(function () {
  var hamburger = document.getElementById('hamburger');
  var navClose = document.getElementById('navClose');
  var mobileNav = document.getElementById('mobileNav');
  var navOverlay = document.getElementById('navOverlay');

  function openNav() {
    if (mobileNav) { mobileNav.classList.add('is-open'); mobileNav.setAttribute('aria-hidden','false'); }
    if (navOverlay) navOverlay.classList.add('is-active');
    if (hamburger) hamburger.setAttribute('aria-expanded','true');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    if (mobileNav) { mobileNav.classList.remove('is-open'); mobileNav.setAttribute('aria-hidden','true'); }
    if (navOverlay) navOverlay.classList.remove('is-active');
    if (hamburger) hamburger.setAttribute('aria-expanded','false');
    document.body.style.overflow = '';
  }
  if (hamburger) hamburger.addEventListener('click', openNav);
  if (navClose) navClose.addEventListener('click', closeNav);
  if (navOverlay) navOverlay.addEventListener('click', closeNav);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeNav(); });
})();

// ----- CART (Shopify connected) -----
(function() {
  var SHOPIFY_CART_URL = 'https://krax1y-7z.myshopify.com/cart';
  var cartCount = document.getElementById('cartCount');
  var count = parseInt(localStorage.getItem('a44cart') || '0');

  function updateCount() {
    if (!cartCount) return;
    cartCount.textContent = count;
    cartCount.setAttribute('data-count', count);
    cartCount.style.display = count > 0 ? 'flex' : 'none';
  }

  // Cart icon → go to Shopify cart
  var cartBtn = document.getElementById('cartBtn');
  if (cartBtn) {
    cartBtn.addEventListener('click', function() {
      window.location.href = SHOPIFY_CART_URL;
    });
  }

  // Fallback addToCart (overridden on product page by shopify-connect.js)
  if (!window.addToCart) {
    window.addToCart = function() {
      count++;
      localStorage.setItem('a44cart', count);
      updateCount();
      var btn = document.querySelector('.btn-atc') || document.getElementById('stickyAtcBtn');
      if (btn) {
        var original = btn.textContent;
        btn.textContent = 'Added!';
        btn.style.background = '#1a6e1a';
        btn.style.borderColor = '#1a6e1a';
        setTimeout(function() {
          btn.textContent = original;
          btn.style.background = '';
          btn.style.borderColor = '';
        }, 1400);
      }
    };
  }

  updateCount();
})();

// ----- DRAG SCROLL HELPER -----
function enableDragScroll(el) {
  if (!el) return;
  var isDown = false, startX, scrollLeft;
  el.addEventListener('mousedown', function(e) {
    isDown = true; el.style.cursor = 'grabbing';
    startX = e.pageX - el.offsetLeft; scrollLeft = el.scrollLeft;
  });
  el.addEventListener('mouseleave', function() { isDown = false; el.style.cursor = 'grab'; });
  el.addEventListener('mouseup', function() { isDown = false; el.style.cursor = 'grab'; });
  el.addEventListener('mousemove', function(e) {
    if (!isDown) return; e.preventDefault();
    el.scrollLeft = scrollLeft - (e.pageX - el.offsetLeft - startX) * 1.4;
  });
}

// ----- PRODUCT CARD RENDERER -----
function renderProductCard(p, isSale) {
  var price = isSale ? 99 : p.price;
  var priceHtml = isSale
    ? '<span class="product-card__price product-card__price--sale">$' + price + '</span><span class="product-card__price--original">$' + p.price + '</span>'
    : '<span class="product-card__price">$' + price + '</span>';
  var soldOut = p.inventory === 0;
  return '<a href="product.html?id=' + p.id + (isSale ? '&sale=1' : '') + '" class="product-card">' +
    '<div class="product-card__media">' +
      '<img src="' + p.images[0] + '" alt="' + p.title + '" loading="lazy">' +
      (soldOut
        ? '<span class="product-card__badge">Sold Out</span>'
        : '<span class="product-card__badge">' + p.scarcity + '</span>') +
      (isSale ? '<span class="product-card__sale-badge">$99 Sale</span>' : '') +
    '</div>' +
    '<div class="product-card__body">' +
      '<div class="product-card__rating"><span class="stars">&#9733;&#9733;&#9733;&#9733;&#9733;</span><span class="rating-count">&nbsp;(248)</span></div>' +
      '<p class="product-card__vendor">Chrome Hearts</p>' +
      '<h3 class="product-card__title">' + p.title + '</h3>' +
      priceHtml +
    '</div>' +
  '</a>';
}

// ----- FEATURED GRID (homepage — 8 products) -----
(function () {
  var featuredGrid = document.getElementById('featuredGrid');
  if (!featuredGrid || typeof PRODUCTS === 'undefined') return;
  // Pick 8 non-sale products
  var featured = PRODUCTS.filter(function(p){ return !(p.tags && p.tags.indexOf('sale') !== -1); }).slice(0, 8);
  featuredGrid.innerHTML = featured.map(function(p) { return renderProductCard(p, false); }).join('');
})();

// ----- $99 SALE GRID (homepage — 4 products) -----
(function () {
  var saleGrid = document.getElementById('saleGrid');
  if (!saleGrid || typeof PRODUCTS === 'undefined') return;
  var saleProducts = PRODUCTS.filter(function(p){ return p.tags && p.tags.indexOf('sale') !== -1; }).slice(0, 4);
  saleGrid.innerHTML = saleProducts.map(function(p) { return renderProductCard(p, true); }).join('');
})();

// ----- HUMAN-FEELING REVIEWS (homepage) -----
(function () {
  var reviewsGrid = document.getElementById('reviewsGrid');
  if (!reviewsGrid) return;

  var humanReviews = [
    { name: 'Jordan M.', city: 'New York', rating: 5, date: 'Mar 12, 2025', body: 'Perfect.' },
    { name: 'Sofia R.', city: 'Los Angeles', rating: 5, date: 'Feb 28, 2025', body: 'The frames arrived in perfect condition. Packaging is legitimately impressive — you can tell these are the real thing the second you open the box. Came with everything: the case, the cloth, the pouch. 10/10.' },
    { name: 'Ethan K.', city: 'Miami', rating: 5, date: 'Apr 3, 2025', body: 'Fire.' },
    { name: 'Maya T.', city: 'Toronto', rating: 5, date: 'Jan 18, 2025', body: 'I was honestly nervous ordering online but these are 100% legit. You can feel the quality difference immediately. Already looking at my next pair.' },
    { name: 'Luca B.', city: 'London', rating: 5, date: 'Mar 7, 2025', body: 'Shipped super fast and came with the full CH box. My favorite purchase this year.' },
    { name: 'Naomi S.', city: 'Paris', rating: 5, date: 'Feb 14, 2025', body: 'Worth every penny. The leather case alone is beautiful.' },
    { name: 'Miles J.', city: 'Seoul', rating: 4, date: 'Dec 20, 2024', body: 'Great frames, authenticity was verified. Shipping took a bit longer than expected but got everything in perfect shape. Would recommend.' },
    { name: 'Ava D.', city: 'Melbourne', rating: 5, date: 'Apr 10, 2025', body: 'Obsessed.' },
    { name: 'Noah P.', city: 'Chicago', rating: 5, date: 'Mar 22, 2025', body: 'The unboxing is actually sick. Wasn\'t expecting it to feel this premium. Everyone asks where I got them.' },
    { name: 'Zara H.', city: 'Dubai', rating: 5, date: 'Jan 30, 2025', body: 'Archive44 is the real deal. Got my order within a week and the frames came exactly as described with the full packaging. No complaints at all.' },
    { name: 'Leo C.', city: 'New York', rating: 5, date: 'Feb 5, 2025', body: 'g.' },
    { name: 'Jade N.', city: 'Los Angeles', rating: 5, date: 'Mar 1, 2025', body: 'These are genuinely hard to find and Archive44 had them. Packaging was immaculate. The cross hardware on the case is a nice touch. Really happy with this purchase.' },
    { name: 'Owen F.', city: 'Toronto', rating: 5, date: 'Apr 8, 2025', body: 'Fast shipping, legit frames. Already on my second order.' },
    { name: 'Layla M.', city: 'London', rating: 5, date: 'Dec 28, 2024', body: 'The Smoke Show frames are unreal in person. Pictures don\'t do them justice at all. Came with everything you\'d expect from CH retail. Very impressed.' },
    { name: 'Jules V.', city: 'Miami', rating: 5, date: 'Feb 22, 2025', body: 'crazy good' },
    { name: 'Amara D.', city: 'Paris', rating: 5, date: 'Jan 5, 2025', body: 'Bought as a gift and the recipient was blown away by the packaging. Looks incredibly premium. Shipping was global and fast.' },
    { name: 'Theo G.', city: 'Sydney', rating: 5, date: 'Mar 16, 2025', body: 'Clean frames, clean transaction. Would buy again.' },
    { name: 'Mina I.', city: 'Seoul', rating: 5, date: 'Feb 9, 2025', body: 'Already recommended Archive44 to like 4 people. The frames are exactly what I was looking for and they came in perfect condition.' }
  ];

  reviewsGrid.innerHTML = humanReviews.map(function(r) {
    var stars = r.rating === 5 ? '&#9733;&#9733;&#9733;&#9733;&#9733;' : '&#9733;&#9733;&#9733;&#9733;&#9734;';
    return '<div class="review-card">' +
      '<div class="review-header"><span class="review-name">' + r.name + '</span><span class="verified-badge">Verified</span></div>' +
      '<div class="review-rating">' + stars + '</div>' +
      '<div class="review-meta">' + r.city + ' &nbsp;&middot;&nbsp; ' + r.date + '</div>' +
      '<p class="review-body">' + r.body + '</p>' +
    '</div>';
  }).join('');

  enableDragScroll(reviewsGrid);
})();

// ----- DRAG SCROLL: Editorial strip -----
(function() {
  var el = document.getElementById('editorialStrip');
  enableDragScroll(el);
})();

// ----- DRAG SCROLL: Editorial strip inner -----
(function() {
  // Also make the scroll wrap itself drag-scrollable
  var wrap = document.querySelector('.editorial-scroll-wrap');
  enableDragScroll(wrap);
})();

// ----- DRAG SCROLL: Instagram Reels strip -----
(function() {
  var wrap = document.querySelector('.reels-scroll-wrap');
  enableDragScroll(wrap);
  var strip = document.getElementById('reelsStrip');
  enableDragScroll(strip);
})();

// ----- DRAG SCROLL: Category carousel -----
(function() {
  var carousel = document.getElementById('catCarousel');
  enableDragScroll(carousel);
})();
